<template>
  <v-container fluid>
    <!-- <v-dialog v-model="show" > -->
    <v-card elevation="0">
      <v-toolbar>
        <v-icon>playlist_add_check</v-icon>
        <v-toolbar-title class="font-weight-light">
          <v-row>
            <v-col>
              <div>
                &nbsp;Créditos de {{ infoPersona.nombreCompleto }} -
                <span @click="showId = true">{{
                  infoPersona.documentoCompleto
                }}</span>
              </div>
              <span v-if="showId" class="caption"
                >ID Persona: {{ infoPersona.id }}</span
              >
            </v-col>
          </v-row>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.stop="hideActiveTask"><v-icon>close</v-icon></v-btn>
      </v-toolbar>

      <v-card-title>
        <v-row no-gutters v-if="infoPersona.comportamiento">
          <v-col>
            <v-banner color="info" dark sticky icon="info" small single-line>
              <div class="d-flex justify-space-between w-100">
                <span
                  >El Cliente es :
                  {{ infoPersona.comportamiento.categoriaDescripcion }} /
                  {{ infoPersona.comportamiento.calificacionDescripcion }}
                </span>
                <span
                  >Origen :
                  {{ infoPersona.tipoRegistroDescripcion }}
                </span>
              </div>
            </v-banner>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col sm8>
            <v-banner>
              <div class="body-1">
                Situación: {{ infoPersona.situacion }}
                <v-btn
                  x-small
                  icon
                  @click="updateSituacion"
                  v-if="checkCanAccess('ap-puede-actualizar-situacion')"
                  ><v-icon>refresh</v-icon></v-btn
                >
              </div>
              <div></div>
            </v-banner>
          </v-col>
          <v-col sm="2" class="text-right pa-4">
            <v-badge>
              <template v-slot:badge>
                <span class="caption">{{
                  infoPersona.cantidadCreditosActivos
                }}</span>
              </template>
              <span class="caption">Activos</span>
            </v-badge>
            <v-spacer></v-spacer>
            <v-badge color="brown">
              <template v-slot:badge>
                <span class="caption">{{
                  infoPersona.cantidadCreditosCancelados
                }}</span>
              </template>
              <span class="caption">Cancelados</span>
            </v-badge>
          </v-col>
        </v-row>
      </v-card-title>

      <v-row no-gutters>
        <v-col>
          <span class="caption">Incluir:</span>
          <v-btn-toggle dense multiple tile color="deep-purple accent-3" group>
            <v-btn
              value="incluirConsultas"
              @click="incluirConsultas = !incluirConsultas"
              small
            >
              Consultas
            </v-btn>

            <v-btn
              value="incluirAnuladosRechazados"
              @click="incluirAnuladosRechazados = !incluirAnuladosRechazados"
              small
            >
              Anulados y Rechazados
            </v-btn>
          </v-btn-toggle>
        </v-col>
      </v-row>
      <v-divider></v-divider>

      <v-card-text v-if="itemsCuentaGastos.length > 0">
        <v-container fluid>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <v-row align="center" no-gutters>
                  <v-col cols="1">
                    <v-icon color="orange">info </v-icon>
                  </v-col>
                  <v-col>
                    <div>Tiene Cuenta de Capitalización</div>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card dense>
                  <v-toolbar dense>
                    <v-toolbar-title class="font-weight-light"
                      >Cuenta de Capitalización</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                  </v-toolbar>

                  <v-data-table
                    dense
                    :headers="headersCuentaGastos"
                    :items="itemsCuentaGastos"
                    :server-items-length="itemsCuentaGastos.length"
                    :rows-per-page="5"
                    :loading="loading"
                    item-key="id"
                  >
                    <template v-slot:item="{ item }">
                      <tr>
                        <td class="text-xs-left caption">
                          {{
                            item.fecha
                              | dateParse("YYYY-MM-DD")
                              | dateFormat("DD-MM-YY")
                          }}
                        </td>
                        <td class="text-xs-left caption">{{ item.tipo }}</td>
                        <td class="text-right caption">
                          {{ item.importe | currency }}
                        </td>
                        <td class="text-right caption">
                          {{ item.saldo | currency }}
                        </td>

                        <td class="text-xs-left caption">{{ item.origen }}</td>
                        <td class="text-xs-left caption">
                          {{ item.comentarios }}
                        </td>

                        <td class="text-xs-left caption">
                          <v-chip small :color="item.empresaColor" label dark>{{
                            item.empresaShort
                          }}</v-chip>
                        </td>
                      </tr>
                    </template>
                    <template v-slot:body.append="{}">
                      <tr class="text-xs-right caption grey">
                        <td></td>
                        <td class="caption">SALDOS</td>
                        <td></td>
                        <td class="text-right caption">
                          {{ saldoCuentaGastosTotal | currency }}
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-container>
      </v-card-text>

      <v-card-text>
        <v-container fluid v-if="vistaDataTabla">
          <v-data-table
            :headers="headers"
            :items="items"
            show-expand
            single-expand
            class="elevation-1"
          >
            <template v-slot:item.empresa="{ item }">
              <v-chip :color="item.empresaColor" dark>{{
                item.empresa
              }}</v-chip>
            </template>
          </v-data-table>
        </v-container>

        <v-container v-else>
          <div v-if="loadingCreditos">
            Cargando Créditos. Aguarde un instante...
          </div>
          <v-skeleton-loader
            type="article"
            :loading="loadingCreditos && totalItemsCargados == 0"
            transition="scale-transition"
          >
            <v-layout column>
              <v-flex
                v-for="item in items"
                :key="item.creditoId"
                xs12
                sm12
                md10
                lg8
              >
                <v-card dense>
                  <v-card-text>
                    <div class="title mb-1">
                      <span v-if="item.productoDescripcion == 'Acuerdo'">
                        Acuerdo de Pago Nº {{ item.numero }} de
                        <v-chip dark :color="item.empresaColor">
                          {{ item.empresa }}
                        </v-chip>
                      </span>
                      <span v-else>
                        Crédito Nº {{ item.numero }} de {{ item.canalVenta }} de
                        <v-chip dark :color="item.empresaColor">
                          {{ item.empresa }}
                        </v-chip>
                      </span>

                      <v-chip outlined>
                        {{
                          item.estadoDescripcion != item.subEstadoDescripcion
                            ? item.estadoDescripcion
                            : ""
                        }}
                        {{ item.subEstadoDescripcion }}
                      </v-chip>

                      <v-chip
                        outlined
                        v-if="item.botonDeArrepentimiento == true"
                      >
                        {{ "por Botón de Arrepentimiento" }}
                      </v-chip>

                      <v-chip
                        v-if="item.origenId == 2"
                        color="orange"
                        text-color="white"
                        dark
                      >
                        {{ "APP" }}
                      </v-chip>
                    </div>

                    <div v-if="item.avisos && item.avisos.length > 0">
                      <v-divider></v-divider>

                      <template v-for="aviso in item.avisos">
                        <v-row :key="aviso.aviso" dense>
                          <v-col>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <div
                                  v-on="on"
                                  :class="
                                    'body-2 ' +
                                    aviso.color +
                                    '--text text-right'
                                  "
                                >
                                  <v-icon :color="aviso.color">{{
                                    aviso.icon
                                  }}</v-icon>
                                  {{ aviso.aviso }}
                                </div>
                              </template>
                              <span>{{ aviso.masDatos }}</span>
                            </v-tooltip>
                          </v-col>
                        </v-row>
                      </template>
                      <v-divider></v-divider>
                    </div>

                    <div class="caption" v-if="item.cargosServicio > 0">
                      Monto
                      <span class="caption">
                        {{ (item.capital - item.cargosServicio) | currency }} +
                        {{ item.cargosServicio | currency }} beneficios =
                        {{ item.capital | currency }}

                        en
                        {{ item.cuotas }} cuotas de
                        {{ item.importeCuota | currency }}
                      </span>
                    </div>
                    <div class="caption" v-else>
                      Monto
                      <span class="caption">
                        {{ item.capital | currency }} en
                        {{ item.cuotas }} cuotas de
                        {{ item.importeCuota | currency }}
                      </span>
                    </div>
                    <div class="caption" v-if="item.saldoTotal > 0">
                      Saldo Vencido
                      <span class="caption"
                        >{{ item.saldoVencido | currency }} /
                      </span>
                      Saldo Total
                      <span class="caption">
                        {{ item.saldoTotal | currency }} /
                      </span>
                      Saldo Capital
                      <span class="caption">
                        {{ item.saldoCapital | currency }} /
                      </span>
                      Saldo Punitorios
                      <span class="caption">
                        {{ item.saldoPunitorios | currency }}
                      </span>
                      <v-chip :color="item.statusMoraColor" dark small>
                        <span class="caption"> {{ item.statusMora }} </span>
                      </v-chip>
                      <v-chip
                        color="orange"
                        dark
                        v-if="item.tieneAcuerdo"
                        small
                      >
                        <span class="caption">
                          Con Acuerdo Nº {{ item.numeroAcuerdo }}
                        </span>
                      </v-chip>
                      <v-chip v-if="item.vendido" color="purple" dark small>
                        <span class="caption">
                          Vendida: {{ item.ventaDescripcion }}
                        </span>
                      </v-chip>
                    </div>

                    <div
                      class="caption"
                      v-if="item.productoDescripcion != 'CUPONIZATE'"
                    >
                      T.N.A. {{ (item.tna * 100).toFixed(2) }} / T.E.A.
                      {{ (item.tea * 100).toFixed(2) }} / C.F.T.
                      {{ (item.cft * 100).toFixed(2) }}
                    </div>

                    <div class="caption">
                      Ingresado el
                      <span class="caption">
                        {{ item.fechaIngreso | formatDate }} -
                      </span>
                      {{
                        item.productoDescripcion == "Acuerdo"
                          ? "Aprobado"
                          : "Liquidado"
                      }}
                      el
                      <span class="caption">
                        {{ item.fechaLiquidacion | formatDate }}
                      </span>
                    </div>

                    <div
                      class="caption"
                      v-if="item.productoDescripcion == 'CUPONIZATE'"
                    >
                      Producto
                      <span class="caption">
                        <v-chip color="pink" small dark label
                          >CUPONIZATE</v-chip
                        >
                      </span>

                      <span class="caption">
                        {{ item.medioPago }}
                      </span>
                      /
                      <span class="caption">
                        {{ item.debitoEnCuentaBanco }}
                      </span>
                      <v-chip color="yellow" dark small>
                        <span class="caption black--text">
                          Tilde activo por {{ item.medioPago }}
                        </span>
                      </v-chip>
                    </div>

                    <div
                      class="caption"
                      v-else-if="item.productoDescripcion != 'Acuerdo'"
                    >
                      Producto
                      <span class="caption">
                        {{ item.productoDescripcion }} /
                      </span>
                      Plan
                      <span class="caption">
                        {{ item.planDescripcion }} /
                      </span>
                      <span class="caption">
                        {{ item.medioPago }}
                      </span>
                      /
                      <span class="caption">
                        {{ item.debitoEnCuentaBanco }}
                      </span>
                      <v-chip color="yellow" dark small>
                        <span class="caption black--text">
                          Tilde activo por {{ item.medioPago }}
                        </span>
                      </v-chip>
                    </div>
                    <div class="caption" v-else>
                      Deudas Incluidas:
                      <span class="caption"> {{ item.planDescripcion }} </span>
                    </div>
                    <!-- <div v-if="checkCanAccess('ap-ver-info-precancelacion')" class="caption indigo--text"> -->
                    <div
                      v-if="
                        item.productoDescripcion != 'Acuerdo' &&
                        item.productoDescripcion.toUpperCase() !=
                          'CUPONIZATE' &&
                        item.fechaIngreso >= '2021-01-01' &&
                        checkCanAccess('ap-ver-info-precancelacion')
                      "
                      class="caption indigo--text"
                    >
                      Precancelación:
                      <v-chip
                        dark
                        color="indigo"
                        label
                        @click="loadDatosPrecancelacion(item)"
                        small
                        >Calcular</v-chip
                      >
                      <span v-if="item.datosPrecancelacion">
                        &nbsp; Saldo a Precancelar:
                        <v-chip dark color="indigo" label small>
                          $ {{ item.datosPrecancelacion.total }}
                        </v-chip>
                      </span>
                    </div>
                    <div v-if="item.datosPrecancelacion">
                      <v-row align="bottom" dense>
                        <v-col cols="4">
                          <v-text-field
                            dense
                            solo
                            label=""
                            v-model="fechaCalculoPreca"
                            type="date"
                            prefix="al"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </div>

                    <div
                      class="caption pink--text"
                      v-if="item.mostrarCalculoRenovacion"
                    >
                      Renovación Anticipada
                      <v-chip
                        dark
                        color="pink"
                        label
                        @click="calcularRenovacion(item)"
                        small
                        >Calcular</v-chip
                      >

                      <v-chip
                        v-if="item.infoRenovacion"
                        dark
                        color="indigo"
                        label
                        @click="calcularRenovacion(item)"
                        small
                        >Saldo a Renovar:
                        {{
                          item.infoRenovacion.totalARenovar | currency
                        }}</v-chip
                      >
                    </div>

                    <div v-if="item.migrada" class="caption orange--text">
                      Crédito Migrado de Smart
                      <v-chip
                        v-if="!item.datosMigracion"
                        dark
                        color="orange"
                        label
                        @click="loadInfoMigracion(item)"
                        x-small
                        >Ver Info</v-chip
                      >
                    </div>
                    <div v-if="item.datosMigracion" class="caption brown--text">
                      Canal de Venta: {{ item.datosMigracion.canalVenta }} /
                      Producto: {{ item.datosMigracion.producto }} / Plan:
                      {{ item.datosMigracion.planNombre }}
                    </div>
                    <div v-if="checkCanAccess('ap-puede-ver-anulaciones')">
                      <v-chip
                        dark
                        color="red"
                        label
                        @click="procesarReporte(item)"
                        x-small
                        >Ver Anulaciones</v-chip
                      >
                    </div>
                  </v-card-text>
                  <v-container v-if="isExpandedCuentaCorriente(item)">
                    <v-subheader>
                      <v-row align="center">
                        <v-text-field
                          dense
                          readonly
                          solo
                          label=""
                          :value="getDescripcionCuenta(item)"
                        >
                        </v-text-field>

                        <span>
                          <v-text-field
                            dense
                            solo
                            label=""
                            v-model="fechaCuentaCorriente"
                            type="date"
                            append-icon="date_range"
                            prefix="al"
                          ></v-text-field>
                        </span>
                      </v-row>
                    </v-subheader>
                    <v-divider></v-divider>
                    <v-data-table
                      fixed-header
                      :headers="headersCuentaCorriente"
                      :items="cuentaCorriente"
                      :loading="loadingCuentaCorriente"
                      loading-text="Cargando Cuenta Corriente..."
                      dense
                    >
                      <template v-slot:no-data>
                        No se encontraron datos
                      </template>

                      <template v-slot:item="{ item }">
                        <tr v-if="!cuentaCorrienteDetallada">
                          <td
                            v-if="item.tipo == 'CUOTA'"
                            class="text-xs-left caption orange"
                          >
                            {{ item.fecha | formatDate }}
                          </td>
                          <td v-else class="text-xs-left caption">
                            {{ item.fecha | formatDate }}
                          </td>

                          <td class="text-xs-left caption">
                            <tr>
                              {{
                                item.tipo == "PAGO" ? "" : ""
                              }}
                              {{
                                item.concepto
                              }}
                            </tr>
                            <tr v-if="item.masDatos != ''">
                              {{
                                item.masDatos
                              }}
                            </tr>
                          </td>

                          <!-- <td>
                                                    <v-tooltip bottom v-if="item.tipo == 'PAGO'">
                                                        <template v-slot:activator="{ on }">
                                                        <v-btn icon  x-small color="orange" v-on="on" @click="verCajaPago(item)">
                                                            <v-icon>business_center</v-icon>
                                                        </v-btn>
                                                        </template>
                                                        <span>Click para ver caja donde se aplicó el pago</span>                                                       
                                                    </v-tooltip>
                                                </td> -->

                          <td class="text-xs-right caption">
                            {{ item.importe | currency }}
                          </td>
                          <td class="text-xs-right caption">
                            {{
                              (item.punitorios + item.cargosAtraso) | currency
                            }}
                          </td>
                          <td class="text-xs-right caption">
                            {{ item.saldo | currency }}

                            <!-- <v-tooltip v-if="item.situacion.includes('Atrasada') && item.punitorios ==0" bottom>
                                                        <template v-slot:activator="{ on }">
                                                        <v-btn icon  x-small color="purple" v-on="on">
                                                            <v-icon>help</v-icon>
                                                        </v-btn>
                                                        </template>
                                                        <span>Punitorio {{$store.state.parametrosGenerales.porcentajeCalculoPunitoriosCtaCte * 100}}%: {{ (item.saldo * $store.state.parametrosGenerales.porcentajeCalculoPunitoriosCtaCte) | currency}}</span>
                                                    </v-tooltip> -->

                            <v-tooltip
                              v-if="item.punitorioPendiente > 0"
                              bottom
                            >
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  icon
                                  x-small
                                  color="indigo"
                                  v-on="on"
                                  @click="verCuentaPunitorios(item)"
                                >
                                  <v-icon>help</v-icon>
                                </v-btn>
                              </template>
                              <span
                                >Punitorio Pendiente
                                {{ item.punitorioPendiente | currency }} (click
                                para ver detalle)</span
                              >
                            </v-tooltip>
                          </td>
                          <td class="text-xs-left caption">
                            <div
                              v-if="item.situacion.includes('Atrasada')"
                              style="color: red"
                            >
                              {{ item.situacion }}
                            </div>
                            <div v-else>{{ item.situacion }}</div>
                          </td>

                          <td
                            class="text-xs-left caption"
                            v-if="
                              checkCanAccess('ap-reversar-pagos') &&
                              creditoSeleccionado.estadoDescripcion == 'Activa'
                            "
                          >
                            <v-tooltip v-if="item.tipo == 'PAGO'" bottom>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  icon
                                  x-small
                                  color="red"
                                  v-on="on"
                                  @click="
                                    pagoAReversar = item;
                                    showReversoPago = true;
                                  "
                                >
                                  <v-icon>cancel</v-icon>
                                </v-btn>
                              </template>
                              <span>Reversar Pago</span>
                            </v-tooltip>
                          </td>
                        </tr>
                        <tr v-if="cuentaCorrienteDetallada">
                          <td
                            v-if="item.tipo == 'CUOTA'"
                            class="text-xs-left caption orange"
                          >
                            {{ item.fecha | formatDate }}
                          </td>
                          <td v-else class="text-xs-left caption">
                            {{ item.fecha | formatDate }}
                          </td>
                          <td class="text-xs-left caption font-weight-light">
                            <tr>
                              {{
                                item.tipo == "PAGO" ? "" : ""
                              }}
                              {{
                                item.concepto
                              }}
                            </tr>
                            <tr v-if="item.masDatos != ''">
                              {{
                                item.masDatos
                              }}
                            </tr>
                          </td>

                          <td class="text-xs-right caption">
                            {{ item.capital | currency }}
                          </td>
                          <td class="text-xs-right caption">
                            {{ item.interes | currency }}
                          </td>
                          <td class="text-xs-right caption">
                            {{ item.cargos | currency }}
                          </td>
                          <td class="text-xs-right caption">
                            {{ item.punitorios | currency }}
                          </td>
                          <td class="text-xs-right caption">
                            {{ item.cargosAtraso | currency }}
                          </td>
                          <td class="text-xs-right caption">
                            {{ item.saldo | currency }}
                          </td>
                          <td class="text-xs-left caption">
                            <div
                              v-if="item.situacion.includes('Atrasada')"
                              style="color: red"
                            >
                              {{ item.situacion }}
                            </div>
                            <div v-else>{{ item.situacion }}</div>
                          </td>
                        </tr>
                      </template>

                      <template v-slot:body.append="{}">
                        <tr
                          class="text-xs-right caption grey white--text"
                          v-if="!cuentaCorrienteDetallada"
                        >
                          <td></td>
                          <td>SALDOS</td>
                          <td>
                            {{ importeTotal | currency }}
                          </td>
                          <td>
                            {{ cargosAtrasoTotal | currency }}
                          </td>
                          <td>
                            {{ saldoTotal | currency }}
                          </td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr
                          class="text-xs-right font-weight-light white--text grey"
                          v-if="cuentaCorrienteDetallada"
                        >
                          <td></td>
                          <td>SALDOS</td>
                          <td>
                            {{ importeCapitalTotal | currency }}
                          </td>
                          <td>
                            {{ importeInteresTotal | currency }}
                          </td>
                          <td>
                            {{ importeCargosTotal | currency }}
                          </td>
                          <td>
                            {{ importePunitoriosTotal | currency }}
                          </td>
                          <td>
                            {{ cargosAtrasoTotal | currency }}
                          </td>
                          <td>
                            {{ saldoTotal | currency }}
                          </td>
                          <td></td>
                          <td></td>
                        </tr>
                      </template>

                      <!-- <template v-slot:footer>
                                            <div >
                                                TOTALES
                                            </div>
                                        </template> -->
                    </v-data-table>
                  </v-container>

                  <v-container v-if="isExpandedLog(item)">
                    <app-lista-log-acciones-credito
                      :list="solicitud.log"
                      :loading="loadingAcciones"
                      titulo="Log de Acciones sobre el Crédito"
                    ></app-lista-log-acciones-credito>
                  </v-container>

                  <v-card-actions>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          small
                          color="purple"
                          v-on="on"
                          @click="
                            cuentaCorrienteDetallada = false;
                            verCuentaCorriente(item);
                          "
                        >
                          <v-icon>monetization_on</v-icon>
                        </v-btn>
                      </template>
                      <span>Cuenta Corriente</span>
                    </v-tooltip>
                    <v-tooltip
                      bottom
                      v-if="
                        item.productoDescripcion != 'Acuerdo' &&
                        !user.esComer &&
                        !user.esComercio
                      "
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          small
                          color="grey"
                          v-on="on"
                          @click="verAcciones(item)"
                        >
                          <v-icon>chrome_reader_mode</v-icon>
                        </v-btn>
                      </template>
                      <span>Log de Acciones</span>
                    </v-tooltip>
                    <v-tooltip
                      bottom
                      v-if="
                        item.productoDescripcion != 'Acuerdo' &&
                        !user.esComer &&
                        !user.esComercio
                      "
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          small
                          color="brown"
                          v-on="on"
                          @click="verDatosAdicionales(item)"
                        >
                          <v-icon>text_rotation_none</v-icon>
                        </v-btn>
                      </template>
                      <span>Datos Adicionales</span>
                    </v-tooltip>
                    <v-tooltip
                      bottom
                      v-if="
                        item.productoDescripcion != 'Acuerdo' &&
                        !user.esComer &&
                        !user.esComercio
                      "
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          small
                          color="brown"
                          v-on="on"
                          @click="verDatosDebito(item)"
                        >
                          <v-icon>how_to_vote</v-icon>
                        </v-btn>
                      </template>
                      <span>Datos Débito en Cuenta</span>
                    </v-tooltip>
                    <v-tooltip
                      bottom
                      v-if="item.productoDescripcion != 'Acuerdo'"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          small
                          color="black"
                          v-on="on"
                          @click="verDatosTarjeta(item)"
                        >
                          <v-icon>credit_card</v-icon>
                        </v-btn>
                      </template>
                      <span>Datos de Tarjeta</span>
                    </v-tooltip>
                    <v-tooltip
                      bottom
                      v-if="
                        $store.state.parametrosGenerales
                          .auditoriaLegajoDigital &&
                        item.productoDescripcion != 'Acuerdo' &&
                        !user.esComer &&
                        !user.esComercio
                      "
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          small
                          color="blue"
                          v-on="on"
                          @click="verLogLegajoDigital(item)"
                        >
                          <v-icon>receipt</v-icon>
                        </v-btn>
                      </template>
                      <span>Legajo Digital</span>
                    </v-tooltip>
                    <v-tooltip
                      bottom
                      v-if="
                        $store.state.parametrosGenerales
                          .auditoriaLegajoFisico &&
                        item.productoDescripcion != 'Acuerdo' &&
                        !user.esComer &&
                        !user.esComercio
                      "
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          small
                          color="indigo"
                          v-on="on"
                          @click="verLogLegajoFisico(item)"
                        >
                          <v-icon>all_inbox</v-icon>
                        </v-btn>
                      </template>
                      <span>Legajo Físico</span>
                    </v-tooltip>
                    <v-tooltip
                      bottom
                      v-if="
                        item.productoDescripcion == 'Acuerdo' &&
                        !user.esComer &&
                        !user.esComercio
                      "
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          small
                          color="brown"
                          v-on="on"
                          @click="loadDeudasAcuerdo(item)"
                        >
                          <v-icon>info</v-icon>
                        </v-btn>
                      </template>
                      <span>Ver deudas incluidas en el Acuerdo</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          small
                          color="green"
                          v-on="on"
                          @click="pagoEnLinea(item)"
                        >
                          <v-icon>money</v-icon>
                        </v-btn>
                      </template>
                      <span>Pago en Línea</span>
                    </v-tooltip>
                    <v-tooltip
                      bottom
                      v-if="
                        item.tipoProductoDescripcion &&
                        item.tipoProductoDescripcion
                          .toUpperCase()
                          .includes('DIRIGIDO CONSUMO') &&
                        item.subEstadoId >= 51 &&
                        !user.esComer &&
                        !user.esComercio
                      "
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          small
                          color="red"
                          v-on="on"
                          @click="verLogProductoDirigido(item)"
                        >
                          <v-icon>sell</v-icon>
                        </v-btn>
                      </template>
                      <span>Auditoría de Producto Dirigido</span>
                    </v-tooltip>

                    <v-spacer></v-spacer>
                    <v-chip
                      v-if="isExpandedCuentaCorriente(item)"
                      dark
                      color="indigo"
                      label
                      @click="verCuentaPunitorios(item)"
                      x-small
                      >Ver Cta. Punit.</v-chip
                    >
                    <span> &nbsp;</span>

                    <v-chip
                      v-if="isExpandedCuentaCorriente(item)"
                      dark
                      color="blue"
                      label
                      @click="imprimirCtaCte(item)"
                      x-small
                      >Imprimir Cta Cte</v-chip
                    >
                    <span> &nbsp;</span>
                    <v-chip
                      v-if="
                        isExpandedCuentaCorriente(item) &&
                        item.productoDescripcion != 'Acuerdo'
                      "
                      dark
                      color="purple"
                      label
                      @click="
                        cuentaCorrienteDetallada = !cuentaCorrienteDetallada
                      "
                      x-small
                      >{{
                        cuentaCorrienteDetallada
                          ? "Ver C/C Resumida"
                          : "Ver C/C Detallada"
                      }}</v-chip
                    >
                    <span> &nbsp;</span>

                    <v-chip
                      color="pink"
                      dark
                      x-small
                      v-if="
                        item.ejecucionMotorSiisaId > 0 &&
                        checkCanAccess('ap-ver-infomotor')
                      "
                      @click="
                        ejecucionMotorSiisaId = item.ejecucionMotorSiisaId;
                        showVariablesMotor = true;
                      "
                      >Ver Info Motor</v-chip
                    >

                    <app-modificacion-vencimientos
                      v-if="
                        item.estadoDescripcion == 'Activa' &&
                        checkCanAccess('ap-mod-vencimientos')
                      "
                      :creditoId="item.creditoId"
                    ></app-modificacion-vencimientos>
                    <app-impresion-formulario
                      :creditoId="item.creditoId"
                      :empresaId="item.empresaId"
                      :productoDescripcion="item.productoDescripcion"
                    ></app-impresion-formulario>
                  </v-card-actions>
                </v-card>
                <v-row>
                  <v-col>
                    <div></div>
                  </v-col>
                </v-row>
              </v-flex>
            </v-layout>
          </v-skeleton-loader>

          <v-row>
            <v-col cols="12">
              <v-btn
                v-if="totalItems - totalItemsCargados > 0"
                color="red"
                class="white--text"
                width="800"
                :disabled="loadingCreditos"
                @click="loadCreditos"
                >Hay {{ totalItems - totalItemsCargados }} Crédito/s Mas. Cargar
                próximos
                <v-icon>keyboard_arrow_down</v-icon>
                <v-progress-circular
                  v-if="loadingCreditos"
                  indeterminate
                  size="16"
                >
                </v-progress-circular>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-divider></v-divider>
      </v-card-actions>
    </v-card>
    <!-- </v-dialog> -->
    <v-footer fixed>
      <v-btn color="blue darken-1" text @click.stop="hideActiveTask"
        >Cerrar</v-btn
      >
    </v-footer>

    <!-- deudas acuerdo -->
    <v-dialog v-model="showDeudasAcuerdo" width="800">
      <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
        <v-card-title class="headline"
          >Deudas incluidas en el Acuerdo de Pago</v-card-title
        >
        <v-divider></v-divider>
        <v-card-text>
          <v-row class="body-1" dense>
            <v-col> Descripción </v-col>
          </v-row>
          <v-list>
            <v-list-item v-for="item in listDeudasAcuerdo" :key="item.id">
              <template v-if="item.tipoDeudaId == 1">
                <v-row class="body-2" dense>
                  <v-col>
                    <v-chip small :color="item.empresaColor" label dark>{{
                      item.empresa
                    }}</v-chip>
                    Crédito {{ item.numero }}, de {{ item.origen }}
                  </v-col>
                </v-row>
              </template>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- reverso pago -->
    <v-dialog v-model="showReversoPago" width="850">
      <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
        <v-card-title class="headline"
          >Seleccione el Medio de Devolución</v-card-title
        >

        <v-card-text>
          <h3>Movimientos Asociados al Pago a Reversar</h3>
          <!-- {{ movimientosAsociadosPago }} -->
          <v-list>
            <v-list-item
              v-for="item in movimientosAsociadosPago.filter(
                (x) => x.tipo != 'Movimiento',
              )"
              :key="item.id"
            >
              <template>
                <v-row class="body-2" dense>
                  <v-col cols="2"> {{ item.tipo }} </v-col>
                  <v-col cols="2"> {{ item.importe | currency }} </v-col>
                  <v-col> {{ item.info }} </v-col>
                </v-row>
              </template>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text>
          <v-list>
            <v-list-item v-for="item in listMedioDevolucionPago" :key="item.id">
              <template>
                <v-row class="body-2" dense>
                  <v-col> Devolver por {{ item.descripcion }} </v-col>
                  <v-col>
                    <v-btn
                      outlined
                      small
                      @click="anularPago(pagoAReversar, item.id)"
                      >Confirmar
                    </v-btn>
                  </v-col>
                </v-row>
              </template>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- cuenta punitorios -->
    <v-dialog v-model="showCuentaPunitorios" width="800">
      <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
        <v-card-title class="headline"
          >Cuenta Corriente de Punitorios</v-card-title
        >
        <v-divider></v-divider>
        <v-card-text>
          <v-row class="body-1" dense>
            <v-col> Descripción </v-col>
          </v-row>

          <v-data-table
            fixed-header
            :headers="headersCuentaPunitorios"
            :items="cuentaPunitorios"
            :loading="loadingCuentaCorriente"
            loading-text="Cargando Cuenta de Punitorios..."
            dense
          >
            <template v-slot:no-data> No se encontraron datos </template>

            <template v-slot:item="{ item }">
              <tr>
                <td
                  v-if="item.tipo == 'CUOTA'"
                  class="text-xs-left caption orange"
                >
                  {{ item.fecha | formatDate }}
                </td>
                <td v-else class="text-xs-left caption">
                  {{ item.fecha | formatDate }}
                </td>

                <td class="text-xs-left caption">
                  <tr v-if="item.tipo == 'PAGO'">
                    Pago Cuota Nº
                    {{
                      item.cuota
                    }}
                  </tr>
                  <tr v-if="item.tipo == 'CUOTA'">
                    Cuota Nº
                    {{
                      item.cuota
                    }}
                  </tr>
                  <tr v-if="item.tipo == 'QUITA'">
                    Quita Cuota Nº
                    {{
                      item.cuota
                    }}
                  </tr>
                </td>

                <td class="text-right caption">
                  {{ item.importe | currency }}
                </td>
                <td class="text-right caption" v-if="item.tipo == 'CUOTA'">
                  {{ item.saldo | currency }}
                </td>
                <td class="text-xs-right caption" v-else></td>
                <td class="text-xs-left caption">{{ item.masDatos }}</td>
              </tr>
            </template>
            <template v-slot:body.append="{}">
              <tr class="text-xs-right caption grey white--text">
                <td></td>
                <td class="caption">SALDOS</td>
                <td></td>
                <td class="text-right caption">
                  {{ saldoCuentaPunitoriosTotal | currency }}
                </td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- caja de pago -->
    <v-dialog v-model="showCajaPago" persistent width="400">
      <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
        <v-card-title class="headline">Detalle Caja Pago</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row class="body-1" dense>
            <v-col>
              <v-chip v-if="detalleCajaPago" color="green" label dark>{{
                detalleCajaPago.descripcion
              }}</v-chip>
              <span v-else>No se encontró la caja del pago solicitada.</span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="showCajaPago = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- variables motor -->
    <v-dialog v-model="showVariablesMotor" width="1000">
      <app-variables-motor
        :ConsultaMotorId="ejecucionMotorSiisaId"
      ></app-variables-motor>
    </v-dialog>
  </v-container>
</template>

<script>
import Vue from "vue";
import { http } from "@/axios";
import { format } from "date-fns";
import { Decimal } from "decimal.js";

import {
  //  mapState,
  mapGetters,
  mapMutations,
  //  mapActions
} from "vuex";

export default {
  data: () => ({
    headers: [
      // definición de columnas
      { text: "Ingresada el", value: "fechaIngreso", width: 140 },
      { text: "Número", value: "numero", width: 90 },
      { text: "Canal Venta", value: "canalVenta" },
      { text: "Capital", value: "monto", width: 90 },
      { text: "Saldo Vencido", value: "saldoVencido", width: 90 },
      { text: "Saldo Total", value: "saldoTotal" },
      { text: "Saldo Punitorios", value: "saldoPunitorios" },
      { text: "Producto", value: "producto" },
      { text: "Plan", value: "plan" },
      { text: "Empresa", value: "empresa" },
    ],
    headersCuentaCorriente: [
      // definición de columnas
      { text: "Fecha", value: "fecha", width: 100 },
      { text: "Concepto", value: "concepto", width: 200 },
      // { text: '', value: 'verCaja', width: 10 },
      { text: "Importe", value: "importe", width: 120 },
      { text: "Cargos x Atraso", value: "cargosAtraso", width: 110 },
      { text: "Saldo", value: "saldo", width: 120 },
      { text: "Situación", value: "situacion" },
      // { text: 'Más Datos', value: 'masDatos', width: 150},
    ],
    headersCuentaPunitorios: [
      // definición de columnas
      { text: "Fecha", value: "fecha", width: 100 },
      { text: "Concepto", value: "concepto", width: 200 },
      { text: "Importe", value: "importe", width: 120 },
      { text: "Saldo", value: "saldo", width: 120 },
      { text: "Motivo", value: "masDatos" },
    ],
    headersAcciones: [
      // definición de columnas
      { text: "Fecha", value: "fecha", width: 140 },
      { text: "Acción", value: "accion" },
      { text: "Responsable", value: "responsable", width: 90 },
      // { text: 'Comentarios', value: 'comentarios', width: 200},
    ],
    headersCuentaGastos: [
      // definición de columnas
      { text: "Fecha", value: "fecha", width: 90 },
      { text: "Concepto", value: "tipo" },
      { text: "Importe", value: "importe", width: 110 },
      { text: "Saldo", value: "saldo", width: 110 },
      { text: "Origen", value: "origen" },

      { text: "Comentarios", value: "comentarios" },
      { text: "Empresa", value: "empresaShort", width: 100 },
    ],
    vistaDataTabla: false,
    creditoSeleccionado: null,
    cuentaCorriente: [],
    cuentaPunitorios: [],
    totalItemsCuentaCorriente: 0,
    totalItemsCuentaPunitorios: 0,
    loadingCreditos: false,
    loadingCuentaCorriente: false,
    loadingAcciones: false,
    solicitud: {},
    itemsPerPageOptions: [4, 8, 12],
    itemsPerPage: 4,
    items: [],
    itemsCuentaGastos: [],
    infoPersona: {},
    totalItems: 0,
    totalItemsCargados: 0,
    pageCreditos: 0,
    showId: false,
    showCuentaCorriente: false,
    showCuentaPunitorios: false,
    showLog: false,
    showDeudasAcuerdo: false,
    showReversoPago: false,
    listDeudasAcuerdo: [],
    listMedioDevolucionPago: [],
    fechaCuentaCorriente: null,
    cuentaCorrienteDetallada: false,
    incluirConsultas: false,
    incluirAnuladosRechazados: false,
    showVariablesMotor: false,
    ejecucionMotorSiisaId: 0,
    showCajaPago: false,
    detalleCajaPago: null,
    fechaCalculoPreca: null,
    pagoAReversar: null,
    movimientosAsociadosPago: [],
  }),
  props: {
    personaId: {
      type: String,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  filtro: {
    fechaDesde: null,
    fechaHasta: null,
    CreditoId: 1,
  },
  async created() {
    this.fechaCuentaCorriente = this.$moment(new Date()).format("YYYY-MM-DD");
    this.fechaCalculoPreca = this.$moment(new Date()).format("YYYY-MM-DD");
    if (this.personaId) {
      this.showId = false;
      this.pageCreditos = 0;
      this.items = [];

      await this.loadDatosPersona();
      await this.loadCreditos();
      await this.loadCuentaGastos();
      await this.loadMedioDevolucionPago();
    }
  },
  computed: {
    ...mapGetters(["checkCanAccess", "ParametrosGenerales", "user"]),
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
    saldoTotal: function () {
      if (!this.cuentaCorriente) return 0;

      var saldo = 0;

      for (let index = 0; index < this.cuentaCorriente.length; index++) {
        saldo = new Decimal(saldo).plus(this.cuentaCorriente[index].saldo);
      }
      return saldo;
    },
    importeTotal: function () {
      if (!this.cuentaCorriente) return 0;

      var saldo = 0;

      for (let index = 0; index < this.cuentaCorriente.length; index++) {
        saldo = new Decimal(saldo).plus(this.cuentaCorriente[index].importe);
      }
      return saldo;
    },
    importeCapitalTotal: function () {
      if (!this.cuentaCorriente) return 0;

      var saldo = 0;

      for (let index = 0; index < this.cuentaCorriente.length; index++) {
        saldo = new Decimal(saldo).plus(this.cuentaCorriente[index].capital);
      }
      return saldo;
    },
    importeInteresTotal: function () {
      if (!this.cuentaCorriente) return 0;

      var saldo = 0;

      for (let index = 0; index < this.cuentaCorriente.length; index++) {
        saldo = new Decimal(saldo).plus(this.cuentaCorriente[index].interes);
      }
      return saldo;
    },
    importeCargosTotal: function () {
      if (!this.cuentaCorriente) return 0;

      var saldo = 0;

      for (let index = 0; index < this.cuentaCorriente.length; index++) {
        saldo = new Decimal(saldo).plus(this.cuentaCorriente[index].cargos);
      }
      return saldo;
    },
    importePunitoriosTotal: function () {
      if (!this.cuentaCorriente) return 0;

      var saldo = 0;

      for (let index = 0; index < this.cuentaCorriente.length; index++) {
        saldo = new Decimal(saldo).plus(this.cuentaCorriente[index].punitorios);
      }
      return saldo;
    },
    cargosAtrasoTotal: function () {
      if (!this.cuentaCorriente) return 0;

      var saldo = 0;

      for (let index = 0; index < this.cuentaCorriente.length; index++) {
        if (this.cuentaCorrienteDetallada)
          saldo = new Decimal(saldo).plus(
            this.cuentaCorriente[index].cargosAtraso,
          );
        else
          saldo = new Decimal(saldo).plus(
            this.cuentaCorriente[index].cargosAtraso +
              this.cuentaCorriente[index].punitorios,
          );
      }
      return saldo;
    },
    saldoCuentaGastosTotal: function () {
      if (!this.itemsCuentaGastos) return 0;

      var saldo = 0;

      for (let index = 0; index < this.itemsCuentaGastos.length; index++) {
        if (!this.itemsCuentaGastos[index].tipo.includes("Pago"))
          saldo = new Decimal(saldo).plus(this.itemsCuentaGastos[index].saldo);
      }
      return saldo;
    },
    saldoCuentaPunitoriosTotal: function () {
      if (!this.cuentaPunitorios) return 0;

      var saldo = 0;

      for (let index = 0; index < this.cuentaPunitorios.length; index++) {
        if (!this.cuentaPunitorios[index].tipo.includes("Pago"))
          saldo = new Decimal(saldo).plus(this.cuentaPunitorios[index].saldo);
      }
      return saldo;
    },
  },
  watch: {
    visible: function () {
      if (this.visible) {
        this.showId = false;
        this.pageCreditos = 0;
        this.items = [];
        this.itemsCuentaGastos = [];
        this.loadDatosPersona();
        this.loadCreditos();
      }
    },
    showReversoPago: function () {
      if (this.showReversoPago) {
        this.loadMovimientosAsociadosAPago(this.pagoAReversar);
      }
    },
    fechaCuentaCorriente: function () {
      if (this.creditoSeleccionado != null) {
        this.verCuentaCorriente(this.creditoSeleccionado);
      }
    },
    cuentaCorrienteDetallada: function () {
      if (this.cuentaCorrienteDetallada) {
        this.headersCuentaCorriente = [
          // definición de columnas
          { text: "Fecha", value: "fecha", width: 100 },
          { text: "Concepto", value: "concepto", width: 170 },
          // { text: '', value: 'verCaja', width: 20 },
          { text: "Capital", value: "capital", width: 120 },
          { text: "Interés", value: "interes", width: 120 },
          { text: "Cargos", value: "cargos", width: 90 },
          { text: "Punitorios", value: "punitorios", width: 100 },
          { text: "Cargos Atr.", value: "cargosAtraso", width: 90 },
          { text: "Saldo", value: "saldo", width: 120 },
          { text: "Situación", value: "situacion" },
        ];
      } else {
        this.headersCuentaCorriente = [
          // definición de columnas
          { text: "Fecha", value: "fecha", width: 100 },
          { text: "Concepto", value: "concepto", width: 200 },
          // { text: '', value: 'verCaja', width: 20 },
          { text: "Importe", value: "importe", width: 120 },
          { text: "Cargos x Atraso", value: "cargosAtraso", width: 110 },
          { text: "Saldo", value: "saldo", width: 120 },
          { text: "Situación", value: "situacion" },
        ];
      }
    },
    incluirConsultas: async function () {
      this.items = [];
      this.totalItemsCargados = 0;
      this.totalItems = 0;
      this.pageCreditos = 0;
      await this.loadCreditos();
    },
    incluirAnuladosRechazados: async function () {
      this.items = [];
      this.totalItemsCargados = 0;
      this.totalItems = 0;
      this.pageCreditos = 0;
      await this.loadCreditos();
    },
  },
  filters: {
    formatDate: function (value) {
      if (value) return format(value, "DD-MM-YYYY");
    },
    formatMoney: function (value) {
      if (value) {
        if (Number.isInteger(value)) return "$ " + value + ".00";
        else return "$ " + value;
      }
    },
  },
  methods: {
    ...mapMutations([
      "setActiveTask",
      "hideActiveTask",
      "setActiveSubTask",
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
      "setReporteActivo",
    ]),
    loadMedioDevolucionPago() {
      this.listMedioDevolucionPago.push({
        id: 1,
        descripcion: "Trasnferencia",
      });
      this.listMedioDevolucionPago.push({ id: 2, descripcion: "Mercado Pago" });
      this.listMedioDevolucionPago.push({ id: 3, descripcion: "Efectivo" });
    },
    async verCuentaCorriente(item) {
      this.creditoSeleccionado = item;

      this.showCuentaCorriente = true;
      this.showLog = false;
      this.isExpandedCuentaCorriente(item);

      this.cuentaCorriente = [];

      if (item.productoDescripcion == "Acuerdo") {
        // cargo la ctacte del acuerdo
        this.loadingCuentaCorriente = true;
        try {
          var result = await http.get(
            "acuerdos/listcuentacorriente?acuerdoId=" + item.creditoId,
          );
          //console.log(result.list)

          this.cuentaCorriente = result.list;
          this.totalItemsCuentaCorriente = result.totalCount;
        } catch (error) {
          // Error
          this.alertError(error);
        }
      } else {
        // cargo la ctacte del crédito
        this.loadingCuentaCorriente = true;
        try {
          var result = await http.get(
            "creditos/listcuentacorrientedetallada?creditoId=" +
              item.creditoId +
              "&fechaCalculo=" +
              this.$moment(this.fechaCuentaCorriente).format("YYYY-MM-DD"),
          );
          console.log(result);

          this.cuentaCorriente = result.list;
          this.totalItemsCuentaCorriente = result.totalCount;
        } catch (error) {
          // Error
          this.alertError(error);
        }
      }
      this.loadingCuentaCorriente = false;
    },
    async verCuentaPunitorios(item) {
      this.showCuentaPunitorios = true;

      // cargo la cta de punitorios
      this.loadingCuentaCorriente = true;
      try {
        var result = await http.get(
          "creditos/listcuentacorrientepunitorios?creditoId=" + item.creditoId,
        );
        //console.log(result.list)

        this.cuentaPunitorios = result.list;
        this.totalItemsCuentaPunitorios = result.totalCount;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loadingCuentaCorriente = false;
    },
    async verAcciones(item) {
      this.creditoSeleccionado = item;

      this.showCuentaCorriente = false;
      this.showLog = true;
      this.isExpandedCuentaCorriente(item);

      this.loadingAcciones = true;
      try {
        var result = await http.get(
          "Creditos/getinfosolicitudparaanalisis?id=" + item.creditoId,
        );

        this.solicitud = result;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loadingAcciones = false;
    },
    async verCajaPago(item) {
      try {
        var detalleCajaPago = await http.get(
          "cajas/por-pago?pagoId=" + item.id,
        );
        this.showCajaPago = true;
        this.detalleCajaPago = detalleCajaPago;
      } catch (error) {
        // Error
        this.alertError(error);
      }
    },
    async verDatosAdicionales(item) {
      var params = {
        width: 600,
        creditoId: item.creditoId,
      };

      this.setActiveSubTask({
        task: "app-datos-adicionales-credito",
        props: params,
      });
    },
    async verDatosDebito(item) {
      var params = {
        width: 500,
        personaId: this.personaId,
        creditoId: item.creditoId,
      };

      this.setActiveSubTask({
        task: "app-datos-debito-credito",
        props: params,
      });
    },
    async verDatosTarjeta(item) {
      var params = {
        width: 600,
        empresaId: item.empresaId,
        personaId: this.personaId,
        creditoId: item.creditoId,
        standAloneMode: true,
        cuotasPendientesCredito: item.cuotas - item.cuotasPagas,
      };

      this.setActiveSubTask({ task: "app-datos-tarjeta", props: params });
    },
    async verLogLegajoDigital(item) {
      var params = {
        width: 500,
        personaId: this.personaId,
        creditoId: item.creditoId,
      };

      this.setActiveSubTask({ task: "app-log-legajo-digital", props: params });
    },
    async verLogLegajoFisico(item) {
      var params = {
        width: 600,
        personaId: this.personaId,
        creditoId: item.creditoId,
      };

      this.setActiveSubTask({ task: "app-log-legajo-fisico", props: params });
    },
    async verLogProductoDirigido(item) {
      var params = {
        width: 600,
        personaId: this.personaId,
        creditoId: item.creditoId,
      };

      this.setActiveSubTask({
        task: "app-log-producto-dirigido",
        props: params,
      });
    },
    async pagoEnLinea(item) {
      var params = {
        width: 750,
        personaId: this.personaId,
        selectedCredito: item,
      };

      this.setActiveSubTask({ task: "app-pago-on-line", props: params });
    },
    async loadDatosPrecancelacion(credito) {
      // cargo los datos de la migración
      this.loading = true;
      try {
        var result = await http.get(
          "creditos/datosprecancelacion?creditoId=" +
            credito.creditoId +
            "&fechaCalculo=" +
            this.$moment(this.fechaCalculoPreca).format("YYYY-MM-DD"),
        );

        Vue.set(credito, "datosPrecancelacion", result); // agrega la prop como observable para que se actualice el DOM
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadInfoMigracion(credito) {
      // cargo los datos de la migración
      this.loading = true;
      try {
        var result = await http.get(
          "creditos/datosmigracion?creditoId=" + credito.creditoId,
        );

        Vue.set(credito, "datosMigracion", result); // agrega la prop como observable para que se actualice el DOM
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadDatosPersona() {
      // cargo los créditos de la persona
      this.loading = true;
      try {
        var result = await http.get(
          "personas/inforesumida?id=" + this.personaId,
        );

        this.infoPersona = result;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadCreditos() {
      // cargo los créditos de la persona
      this.loadingCreditos = true;
      try {
        if (this.totalItemsCargados < this.totalItems || this.totalItems == 0)
          this.pageCreditos++;

        var result = await http.get(
          "creditos/listporpersona?personaId=" +
            this.personaId +
            "&IncluirConsultas=" +
            this.incluirConsultas +
            "&incluirAnuladosRechazados=" +
            this.incluirAnuladosRechazados +
            "&Limit=5&Page=" +
            this.pageCreditos,
        );

        this.items = this.items.concat(result.list);

        Vue.$log.debug(this.items);
        this.totalItems = result.totalCount;
        this.totalItemsCargados = this.pageCreditos * 5;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loadingCreditos = false;
    },
    async loadCuentaGastos() {
      // cargo la cuenta de gastos de la persona
      this.loadingCreditos = true;
      try {
        var result = await http.get(
          "Personas/listcuentagastos?empresaId=0&id=" +
            this.personaId +
            "&soloConSaldo=false",
        );

        this.itemsCuentaGastos = result.list;
        //console.log(this.itemsCuentaGastos);
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loadingCreditos = false;
    },
    async imprimirCtaCte(item) {
      let params = [];

      if (item.productoDescripcion == "Acuerdo") {
        params.push({
          Nombre: this.infoPersona.nombreCompleto,
          Documento: this.infoPersona.documentoCompleto,
          Numero: item.numero,
          AcuerdoId: item.creditoId, //Credito Id
          FechaCalculo: this.$moment(this.fechaCuentaCorriente).format(
            "YYYY-MM-DD",
          ), // Fecha Cta Cte
        });

        this.setReporteActivo({
          reporte: "CtaCteAcuerdo.trdp",
          params: params,
        });

        window.open("/report-viewer");
      } else {
        params.push({
          Nombre: this.infoPersona.nombreCompleto,
          Documento: this.infoPersona.documentoCompleto,
          Numero: item.numero,
          CreditoId: item.creditoId, //Credito Id
          FechaCalculo: this.$moment(this.fechaCuentaCorriente).format(
            "YYYY-MM-DD",
          ), // Fecha Cta Cte
        });

        this.setReporteActivo({
          reporte: "CtaCteCredito.trdp",
          params: params,
        });

        window.open("/report-viewer");
      }
    },
    async loadDeudasAcuerdo(item) {
      this.listDeudasAcuerdo = [];
      this.loading = true;
      try {
        var result = await http.get(
          "acuerdos/listdeudas" + "?acuerdoId=" + item.creditoId,
        );

        this.listDeudasAcuerdo = result.list;
        console.log(this.listDeudasAcuerdo);
        this.showDeudasAcuerdo = true;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    isExpandedCuentaCorriente: function (item) {
      if (!item || !this.creditoSeleccionado || !this.showCuentaCorriente)
        return false;

      if (item.creditoId == this.creditoSeleccionado.creditoId) return true;
      else return false;
    },
    isExpandedLog: function (item) {
      if (!item || !this.creditoSeleccionado || !this.showLog) return false;

      if (item.creditoId == this.creditoSeleccionado.creditoId) return true;
      else return false;
    },
    getDescripcionCuenta(item) {
      var producto = "";
      if (item.productoDescripcion == "Acuerdo") producto = "Acuerdo";
      else producto = "Crédito";

      return "Cuenta Corriente del " + producto + " Nº " + item.numero;
    },
    validar() {
      if (!this.filtro.creditoId) {
        this.alertWarning("Debe ingresar la Fecha de Ingreso Desde.");
        return false;
      }

      return true;
    },
    async procesarReporte(item) {
      var self = this;

      try {
        self.loading = true;

        let params = [];
        params.push({
          CreditoId: item.creditoId,
        });

        this.setReporteActivo({
          reporte: "Reporte Anulaciones Por Credito.trdp",
          params: params,
        });
        window.open("/report-viewer");
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },
    async updateSituacion() {
      this.loading = true;
      try {
        const formData = new FormData();

        formData.append("personaId", this.personaId);

        await http.post("personas/updatesituacion", formData);
        this.alertSuccess(
          "Los cambios han sido registrados. Se recargará la ventana.",
        );

        // recargo
        await this.loadDatosPersona();
      } catch (error) {
        // Error
        Vue.$log.error(error);
        this.alertError(error);
      }
      this.loading = false;
    },
    async calcularRenovacion(credito) {
      this.loading = true;
      try {
        var result = await http.get(
          "creditos/getinfocalculorenovacion?creditoId=" + credito.creditoId,
        );

        Vue.set(credito, "infoRenovacion", result); // agrega la prop como observable para que se actualice el DOM
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadMovimientosAsociadosAPago(item) {
      try {
        this.loading = true;
        this.movimientosAsociadosPago = await http.get(
          "businesscore/listarmovimientospago?pagoId=" + item.id,
        );
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async anularPago(item, medioId) {
      let res = await this.$dialog.prompt({
        text: "",
        title: "Ingrese el motivo de la anulación.",
      });

      if (res != false) {
        try {
          this.loading = true;
          await http.put(
            "businesscore/reversarpago",
            JSON.stringify({
              pagoId: item.id,
              motivo: res,
              ReversoEn: medioId,
            }),
          );
          this.verCuentaCorriente(this.creditoSeleccionado);
          this.showReversoPago = false;
        } catch (error) {
          // Error
          this.alertError(error);
        }
        this.loading = false;
      }
    },
  },
};
</script>
